import EditBillingInfoFormContainer from './edit-billing-info-form-container';

export default EditBillingInfoFormContainer;
